import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

// Async thunk for creating new agents
export const newAgents = createAsyncThunk(
  'agents/newAgents',
  async (formDataToSend, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${apiUrl}/GetAgents/`, formDataToSend, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Something went wrong';
      return rejectWithValue(errorMessage);
    }
  }
);

// Initial state
const initialState = {
  agents: [],
  loading: false,
  error: null,
};

// Redux slice for agents
const agentsSlice = createSlice({
  name: 'agents',
  initialState,
  reducers: {
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(newAgents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(newAgents.fulfilled, (state, action) => {
        state.loading = false;
        state.agents.push(action.payload); // Assuming `response.data` is a single agent or an array
      })
      .addCase(newAgents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { clearError } = agentsSlice.actions;
export default agentsSlice.reducer;
